// import Permissions from 'src/security/permissions';

import PermissionChecker from "src/modules/auth/permissionChecker";
import getStore from "src/modules/store";

// const permissions = Permissions.values;

const privateRoutes = [
  {
    path: "/home",
    loader: () => {
      const currentUser = getStore().getState().auth.currentUser;
      const currentTenant = getStore().getState().auth.currentTenant;
      const checker = new PermissionChecker(currentTenant, currentUser);

      return checker.isSleepWellPlanActive
        ? import("src/view/sleep-well/SleepWell")
        : import("src/view/home/Home");
    },
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/my-progress",
    loader: () => import("src/view/my-progress/MyProgress"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/frequency-history",
    loader: () => import("src/view/frequency-history/FrequencyHistory"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/my-achievements",
    loader: () => import("src/view/my-achievements/MyAchievements"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/frequencies",
    loader: () => import("src/view/frequencies/Frequencies"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/find-my-frequency",
    loader: () => import("src/view/question/Question"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/question-player",
    loader: () => import("src/view/question-player/QuestionPlayer"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/frequencies-player",
    loader: () => import("src/view/frequencies-player/FrequenciesPlayer"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/frequencies-player",
    loader: () => import("src/view/sound/SoundPlayer"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/vip-wellness-plan",
    loader: () => import("src/view/wellnessCheck/WellnessCheckPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/health-biometrics",
    loader: () => import("src/view/healthBiometrics/HealthBiometricsPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/vip-wellness-plan/:id/intentions",
    loader: () => import("src/view/wellnessCheck/WellnessCheckIntentionsPage"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/vip-wellness-plan/:id/meditations",
    loader: () => import("src/view/wellnessCheck/WellnessCheckMeditationPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/vip-wellness-plan/frequencies",
    loader: () => import("src/view/wellnessCheck/WellnessCheckFrequenciesPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/vip-wellness-plan/results",
    loader: () => import("src/view/wellnessCheck/WellnessCheckResultPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/favorites",
    loader: () => import("src/view/favorite/FavoriteListPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/21-day-focus",
    loader: () => import("src/view/day-programs/DayProgram"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/courses",
    loader: () => import("src/view/courses/courseList"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/courses/:id",
    loader: () => import("src/view/courses/coursesPage"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/courses/:id/lesson-detail",
    loader: () => import("src/view/courses/courseDetail"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/21-day-focus/:id",
    loader: () => import("src/view/day-programs-detail/DayProgramDetail"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/meditation-library",
    loader: () => import("src/view/meditation-library/MeditationLibrary"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/meditation-library/:id",
    loader: () => import("src/view/meditation-library/MeditationLibrary"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/meditation/:id",
    loader: () => import("src/view/meditation-library/MeditationDetail"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/meditation-player",
    loader: () => import("src/view/meditation-player/MeditationPlayer"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/mindfulness",
    loader: () => import("src/view/mindfulness/Mindfulness"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/mindfulness/today-mindful-intention",
    loader: () =>
      import("src/view/mindfulness/mindful-intention/MindfulIntention"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/mindfulness/gratitude-journal",
    loader: () =>
      import("src/view/mindfulness/gratitude-journal/GratitudeJournal"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/mindfulness/preview",
    loader: () => import("src/view/affirmation/AffirmationDetail"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/affirmation/:id",
    loader: () => import("src/view/affirmation/AffirmationViewPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/affirmation/:programSlug/:orderInList",
    loader: () => import("src/view/affirmation/AffirmationViewPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/settings",
    loader: () => import("src/view/settings/Settings"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/settings/profile/edit",
    loader: () => import("src/view/auth/ProfileFormPage"),
    permissionRequired: null,
    exact: true,
  },

  {
    path: "/settings/password-change",
    loader: () => import("src/view/auth/PasswordChangeFormPage"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/settings/manage-subscription",
    loader: () => import("src/view/auth/ManageSubscription"),
    permissionRequired: null,
    exact: true,
  },
  {
    path: "/pricing",
    loader: () => import("src/view/memberShipOptions/MemberShipOptionsPage"),
    permissionRequired: null,
    exact: true,
  },
].filter(Boolean);

const publicRoutes = [
  {
    path: "/auth/login",
    loader: () => import("src/view/auth/SigninPage"),
  },
  {
    path: "/auth/signin",
    loader: () => import("src/view/auth/SigninPage"),
  },
  {
    path: "/auth/signin/:provider",
    loader: () => import("src/view/auth/SigninPage"),
  },
  {
    path: "/auth/signup",
    loader: () => import("src/view/auth/SignupPage"),
  },
  {
    path: "/auth/signup/free-trial",
    loader: () => import("src/view/auth/SignupPage"),
  },
  {
    path: "/auth/signup/paid-trial",
    loader: () => import("src/view/auth/SignupPaidTrialPage"),
  },
  {
    path: "/auth/signup/paid-trial-discount",
    loader: () => import("src/view/auth/SignupPaidTrialDiscountPage"),
  },
  {
    path: "/auth/signup/:provider",
    loader: () => import("src/view/auth/SignupPage"),
  },
  {
    path: "/auth/signup-annually",
    loader: () => import("src/view/auth/SignupAnnuallyPage"),
  },
  {
    path: "/auth/signup-annually/:provider",
    loader: () => import("src/view/auth/SignupAnnuallyPage"),
  },
  {
    path: "/auth/signup-sleep",
    loader: () => import("src/view/auth/SignupSleepPage"),
  },
  {
    path: "/auth/signup-lifetime",
    loader: () => import("src/view/auth/SignupLifetimePage"),
  },
  {
    path: "/auth/survey",
    loader: () => import("src/view/auth/components/UserSurvey"),
  },
  {
    path: "/auth/survey/:provider",
    loader: () => import("src/view/auth/components/UserSurvey"),
  },
  {
    path: "/auth/forgot-password",
    loader: () => import("src/view/auth/ForgotPasswordPage"),
  },
  {
    path: "/auth/subscription/:provider",
    loader: () => import("src/view/auth/SubscriptionPage"),
  },
  {
    path: "/auth/gift",
    loader: () => import("src/view/giftCard/GiftCardPage"),
  },
  {
    path: "/auth/gift/checkout/success",
    loader: () => import("src/view/giftCard/GiftCardPurchaseSuccessPage"),
  },
  {
    path: "/auth/gift/checkout",
    loader: () => import("src/view/giftCard/GiftCardCheckoutPage"),
  },
  {
    path: "/holiday-promo/checkout",
    loader: () => import("src/view/giftCard/HolidayPromoCheckoutPage"),
  },
  {
    path: "/holiday-promo/checkout/success",
    loader: () => import("src/view/giftCard/HolidayPromoSuccessPage"),
  },
].filter(Boolean);

const emptyPermissionsRoutes = [
  {
    path: "/auth/empty-permissions",
    loader: () => import("src/view/auth/EmptyPermissionsPage"),
  },
].filter(Boolean);

const rokuRegisterRoutes = [
  {
    path: "/register",
    loader: () => import("src/view/auth/RokuRegistrationPage"),
  },
].filter(Boolean);

const emailUnverifiedRoutes = [
  {
    path: "/auth/email-unverified",
    loader: () => import("src/view/auth/EmailUnverifiedPage"),
  },
  {
    path: "/auth/email-unverified/:provider",
    loader: () => import("src/view/auth/EmailUnverifiedPage"),
  },
].filter(Boolean);

const completeRegistrationRoutes = [
  {
    path: "/auth/complete-registration",
    loader: () => import("src/view/auth/CompleteRegistrationPage"),
  },
].filter(Boolean);

const subscriptionRoutes = [
  {
    path: "/auth/subscription",
    loader: () => import("src/view/auth/SubscriptionPage"),
  },
  // {
  //   path: '/auth/email-unverified',
  //   loader: () =>
  //     import('src/view/auth/EmailUnverifiedPage'),
  // },
  {
    path: "/auth/email-unverified/:provider",
    loader: () => import("src/view/auth/EmailUnverifiedPage"),
  },

].filter(Boolean);

const simpleRoutes = [
  {
    path: "/auth/signin-voice",
    loader: () => import("src/view/auth/SigninAlexaPage"),
  },
  {
    path: "/auth/password-reset",
    loader: () => import("src/view/auth/PasswordResetPage"),
  },
  {
    path: "/auth/verify-email",
    loader: () => import("src/view/auth/VerifyEmailPage"),
  },
  {
    path: "/403",
    loader: () => import("src/view/shared/errors/Error403Page"),
  },
  {
    path: "/500",
    loader: () => import("src/view/shared/errors/Error500Page"),
  },
  {
    path: "**",
    loader: () => import("src/view/shared/errors/Error404Page"),
  },
 
].filter(Boolean);

export default {
  privateRoutes,
  publicRoutes,
  rokuRegisterRoutes,
  emptyPermissionsRoutes,
  emailUnverifiedRoutes,
  completeRegistrationRoutes,
  subscriptionRoutes,
  simpleRoutes,
};
